import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PricingCard } from '../components/PricingCard';
import { useAuth } from '../contexts/AuthContext';
import toast from 'react-hot-toast';

export function Pricing() {
  const navigate = useNavigate();
  const { user } = useAuth();

  const handleSubscribe = async (priceId: string) => {
    if (!user) {
      toast.error('Você precisa estar logado para assinar');
      navigate('/login');
      return;
    }

    try {
      const response = await fetch(`${import.meta.env.VITE_SUPABASE_URL}/functions/v1/create-checkout`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${import.meta.env.VITE_SUPABASE_ANON_KEY}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          priceId,
          userId: user.id,
          mode: 'subscription'
        }),
      });

      if (!response.ok) {
        throw new Error('Erro ao criar checkout');
      }

      const { url } = await response.json();
      
      if (url) {
        window.location.href = url;
      } else {
        throw new Error('URL de checkout não recebida');
      }
    } catch (error) {
      console.error('Erro no checkout:', error);
      toast.error('Erro ao processar pagamento. Tente novamente.');
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-purple-50">
      <div className="container mx-auto px-4 py-16">
        <div className="text-center mb-16">
          <h1 className="text-5xl font-bold text-gray-900 mb-6">
            Escolha seu Plano
          </h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Transforme sua gestão de eventos com a ferramenta mais completa do mercado
          </p>
        </div>

        <PricingCard onSubscribe={handleSubscribe} />

        <div className="text-center mt-12">
          <p className="text-gray-500">
            Cancele a qualquer momento • Suporte 24/7 • Sem taxas ocultas
          </p>
        </div>
      </div>
    </div>
  );
}